import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import { ActionGuard, LoginGuard } from 'src/app/components/core/_infrastructure/classes/guards/main.guard';
import { RecintoWrapperComponent } from './recinto-wrapper/recinto-wrapper.component';
import { RecintoWrapperEditComponent } from './recinto-wrapper-edit/recinto-wrapper-edit.component';
import { DialogMode } from '../types/enum';

const recintosRoutes: Routes = [
    {
        path: 'campanias/recintos',
        data: {
            breadcrumb: 'Buscador de Recintos',
            menu0: 'Campañas',
            menu1: 'Recintos',
            actionCode: EnumCodigosTwTcAcciones.MENU_RECINTO_CAMPANIA,
            mode: DialogMode.Basic,
        },
        component: RecintoWrapperComponent,
        canActivate: [LoginGuard(), ActionGuard()],
    },
    {
        path: 'campanias/recinto',
        data: {
            breadcrumb: 'Recintos',
            menu0: 'Campañas',
            overridePath: 'campanias/recintos',
            actionCode: EnumCodigosTwTcAcciones.MENU_RECINTO_CAMPANIA,
        },
        children: [
            {
                path: 'edit/:id',
                component: RecintoWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Recinto',
                    actionCode: EnumCodigosTwTcAcciones.MENU_RECINTO_CAMPANIA,
                    editMode: true,
                },
            },
            {
                path: 'view/:id',
                component: RecintoWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Visualizar Recinto',
                    actionCode: EnumCodigosTwTcAcciones.MENU_RECINTO_CAMPANIA,
                    editMode: false,
                },
            },
            {
                path: 'create',
                component: RecintoWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Recinto',
                    actionCode: EnumCodigosTwTcAcciones.MENU_RECINTO_CAMPANIA,
                    editMode: true,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(recintosRoutes)],
    exports: [RouterModule],
})
export class RecintoRoutingModule {}
